/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AuthNumberRestService } from '@gh/builder-shared-data';
import { InitDialogViewService } from '@gh/common-shared';
import { DialogRouteSnapshot } from '@gh/core-ui';

import { Observable } from 'rxjs';
import { AuthNumberRequestConfig } from './../components/auth-number-request-dialog/auth-number-request-dialog.component';

import { AuthNumber, createAuthRequest } from './auth-number.model';

@Injectable()
export class AuthNumberBusinessService implements InitDialogViewService<AuthNumberRequestConfig> {
  constructor(private authNumberRest: AuthNumberRestService) {

  }

  initDialogView(route: DialogRouteSnapshot<AuthNumberRequestConfig>): any {
    return {
      request: this.getSource(createAuthRequest(route.input.entryPoint)),
    };
  }

  generate(authRequest: AuthNumber): Observable<AuthNumber> {
    return this.authNumberRest.generate({ ...authRequest, authNumber: void 0 });
  }

  getSource(authRequest: AuthNumber): Observable<AuthNumber> {
    return this.authNumberRest.getSource(authRequest);
  }

  validate(authRequest: AuthNumber): Observable<AuthNumber> {
    return this.authNumberRest.validate(authRequest);
  }
}
